import React, {useState} from "react";
import Slider from "react-slick";
import moment from 'moment';
import 'moment/locale/he';
import "./HistoryEventsSlider.css";

class HistoryEventsSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tablet: window.innerWidth < 769,
            mobile: window.innerWidth < 650,
            sortedEvents:  this.props.data.slice(0,this.props.historyEventsDisplayCounter),
            allHistoryEventsLink: props.allEventsLink,
            historyEventsDisplayCounter: props.historyEventsDisplayCounter,
            HomePage1HistoryPage2: this.props.HPorP
        };
        window.addEventListener("resize", this.resize.bind(this));
    }

    componentDidUpdate(prevProps){
        if(this.props.data !== prevProps.data) {
            this.setState({sortedEvents: this.props.data.slice(0,this.props.historyEventsDisplayCounter),
            allHistoryEventsLink: this.props.allEventsLink,
            historyEventsDisplayCounter: this.props.historyEventsDisplayCounter});
        }
    }
    // componentWillReceiveProps(props){
    //     this.setState({...this.state.sortedEvents,...props.data});
    // }

    // shouldComponentUpdate(nextProps,NextState) {
    //     debugger;

    //     return true;
    //     
    //     // this.setState({sortedEvents: this.props.data.slice(0,this.props.historyEventsDisplayCounter)});
        
    // }

    resize(){
        let tablet= window.innerWidth < 769;
        let mobile= window.innerWidth < 650;
        if(mobile !== this.state.mobile || tablet !== this.state.tablet){
            this.setState({mobile:mobile,
            tablet:tablet})
        }
        // if(tablet !== this.state.tablet){
        //     this.setState({tablet:tablet})
        // }
        //this.state.mobile ? 1 : (this.state.tablet ? 2 : 3),
    }
    render() {
        const settings ={
            dots: true,
            infinite: true,
            speed:700,            
            slidesToShow: this.state.mobile ? 1 : this.state.historyEventsDisplayCounter,
            rows: 1,
            slidesPerRow: 1,
            slidesToScroll:1,
            centerMode:true,
            autoplay: this.state.tablet ? false : true,
            autoplaySpeed: 8000,
            swipeToSlide: this.state.mobile ? true : false,
            nextArrow: false,
            prevArrow: false,
            adaptiveHeight: false,
            centerPadding:  0
        }
        moment.locale ('he');
    // let sortedEvents = props.data.slice(0,4),
    return (
        <Slider {...settings}>
                    {
                    this.state.sortedEvents.map((event, idx) => 
                    <a href={event.FileRef} target="_blank" key={idx}>
                        <div className="singleHistoryEvent">
                            <div className="singleHistoryEventIn">
                                <div className="imgHistoryEventsContainer">
                                    <img className={this.state.HomePage1HistoryPage2 == 1 ? "imgHistorySingleEventHP":"imgHistorySingleEventP"} src={event.MuseumHistoryEventImg_Url + "?RenditionID=11"} data-holder-rendered="true"  alt={event.Title}/>
                                </div>
                                <div className="historyInfoEventContainer">
                                    <span className="historyEventDate">{moment(event.MuseumHistoryEventDate).format('Do בMMMM YYYY')}</span>
                                    <span className="historyEventTitle" >{event.Title}</span>
                                </div>
                            </div>    
                        </div>
                        </a>)
                    }
                </Slider>
    );}
}
export default HistoryEventsSlider;
